import React from "react";
import ReactDOM from "react-dom";
import RouterNode from "./router";

import "assets/scss/material-kit-react.css?v=1.1.0";


ReactDOM.render(
  <RouterNode/>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js